export default __webpack_public_path__ + "static/media/sketch-club-tn.2d8f4c7a.png";